export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/bundle.43b49904ab6ec2672cf7.worker.js");
}
